var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54545 17C6.92697 17 7.03207 16.7528 6.81876 16.1293L5 9.79257L19 1",
    fill: "#F5F3F8",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.9999C8 16.9999 8.5 16.4999 8.5 16.4999L11.4702 14.4521L7.84149 12.54",
    fill: "#B5BEBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83511 12.5388L15.247 18.7412C16.0928 19.2698 16.7032 18.9961 16.9139 17.8518L19.931 1.7485C20.2398 0.345812 19.4589 -0.290383 18.6497 0.125691L0.93382 7.86303C-0.275458 8.41241 -0.268408 9.17656 0.713393 9.51706L3.51668 10.5081C4.60907 10.8942 5.82117 10.723 6.76386 10.0494L15.7849 3.60322C16.2818 3.26194 16.7378 3.44542 16.3635 3.82167",
    fill: "#C2BCD2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.0bbc2b6e932344acd1b16a1196d06ee1.svg";
export { ForwardRef as ReactComponent };